import React from 'react';
import { Images, isMaintenanceRunning, maintenanceBadges, renderTargetStatuses, targetStatusEnums } from 'utils';
import { StatusCard } from 'components';
import { TrialCircles } from '../session/core/sessionCards/trialCircles';
import { manualTrialSummary } from './constants';
import { useManualTrialEditor } from './useManualTrialEditor';


export const ManualTargetRow = ({ goal, target, trials, onChange, errorTrial, isLast }) => {
    const { single, index, setIndex, total, currentComplete, widgetCurrent, item, renderInput, clearCurrent, errorFields } =
        useManualTrialEditor({ goal, target, trials, onChange, errorTrial });
    // Timed types mark the offending input itself; the row outline is for types with no such field.
    const hasError = errorTrial !== null && errorTrial !== undefined && !errorFields.length;
    // A chip only where it changes what the data means: baseline data, or a maintenance check on a mastered target.
    const status =
        target?.status === targetStatusEnums.BASELINE
            ? renderTargetStatuses?.find((j) => j?.value === targetStatusEnums.BASELINE)
            : isMaintenanceRunning(target)
            ? maintenanceBadges.RUNNING
            : null;
    const summary = manualTrialSummary(goal, trials);
    const canClear = index < trials.length;

    return (
        <div
            className={`target-list-card-wrapper manual-target-row ${hasError ? 'has-error' : ''}`}
            id={`manual-target-${target?.id}`}
            style={isLast ? { borderBottom: 'none', paddingBottom: 0 } : {}}
        >
            <div className="flex-align-start" style={{ gap: 24, borderRight: '1px solid #D0D5DD', alignSelf: 'stretch' }}>
                <div className="target-list-info-box">
                    <p>{target?.label || target?.name}</p>
                </div>

                <div className="target-list-card-btn-wrapper">
                    {!single && (
                        <>
                            <div className="target-list-card-btn">
                                <button
                                    type="button"
                                    disabled={index === 0}
                                    className="list-prev-btn"
                                    onClick={() => setIndex(index - 1)}
                                    style={{ transform: 'rotate(90deg)', opacity: index === 0 ? 0.5 : 1 }}
                                >
                                    <img src={Images.chevronDown} alt="previous trial" />
                                </button>
                                <p>{`${index + 1}/${total}`}</p>
                                <button
                                    type="button"
                                    disabled={!currentComplete}
                                    onClick={() => setIndex(index + 1)}
                                    className="list-next-btn"
                                    style={{ opacity: currentComplete ? 1 : 0.5 }}
                                >
                                    <img src={Images.chevronDown} alt="next trial" />
                                </button>
                            </div>

                            <TrialCircles current={widgetCurrent} item={item} />
                        </>
                    )}
                </div>
            </div>

            <div className="flex-align-center full-width" style={{ gap: 24 }}>
                {/* `full-width` wrapper, as the live Latency / Duration / interval widgets render. */}
                <div className="full-width">{renderInput()}</div>
            </div>

            <div className="flex-align-center" style={{ gap: 12, alignSelf: 'flex-start' }}>
                {status && (
                    <div className="meintenance-list-box">
                        <StatusCard status={status.label} custom={status} />
                    </div>
                )}

                <div className="session-target-info-box">
                    <div className="flex-align-center" style={{ gap: 12 }}>
                        {summary && (
                            <div className="goal-progress-box" style={{ whiteSpace: 'nowrap' }}>
                                {summary}
                            </div>
                        )}
                        <button
                            type="button"
                            title={single ? 'Clear count' : 'Clear this trial'}
                            aria-label={single ? 'Clear count' : 'Clear this trial'}
                            style={{ height: 36, width: 36, opacity: canClear ? 1 : 0.5 }}
                            disabled={!canClear}
                            className="session-gray-action-btn-box"
                            onClick={clearCurrent}
                        >
                            <img src={Images.historyTab} alt="" />
                        </button>
                    </div>
                    {target?.masteryInfo && <p className="session-target-mastery-info">{target.masteryInfo}</p>}
                </div>
            </div>
        </div>
    );
};
